import React from "react";
import {
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useColorMode,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type AvatarProps = {
  username: string;
  onLogout: () => void;
  size?: number; // px
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
};

const Avatar: React.FC<AvatarProps> = ({
  username,
  onLogout,
  size = 36,
  id = "user-avatar",
  firstName,
  lastName,
}) => {
  const { colorMode } = useColorMode();
  const { t } = useTranslation();

  const initials = React.useMemo(() => {
    const letters: string[] = [];
    if (firstName) letters.push(firstName[0]?.toUpperCase() || "");
    if (lastName) letters.push(lastName[0]?.toUpperCase() || "");
    if (!letters.length && username) {
      const parts = username.split(/[@\s._-]+/).filter(Boolean);
      letters.push(...parts.slice(0, 2).map((p) => p[0]?.toUpperCase() || ""));
    }
    const joined = letters.join("").slice(0, 2);
    if (joined) return joined;
    if (username) return username[0]?.toUpperCase() || "?";
    return "?";
  }, [username, firstName, lastName]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        id={id}
        w={`${size}px`}
        h={`${size}px`}
        minW={`${size}px`}
        borderRadius="full"
        p={0}
        bg={colorMode === "light" ? "gray.200" : "gray.600"}
        _hover={{ transform: "translateY(-1px)" }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontWeight="bold"
          fontSize="sm"
        >
          {initials}
        </Box>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={onLogout}>{t("menu.logout")}</MenuItem>
      </MenuList>
    </Menu>
  );
};

export default Avatar;
